export default __webpack_public_path__ + "static/media/a4.5c57ec52.png";